<template>
	<div>
		<div class="card-header">
			<div class="card-header-left">
				<h5>Stage 2: Video Upload</h5>
				<br>
			</div>
		</div>
		<div class="card-block">
			<p>
				<b>Video Upload Instruction:</b>
				{{video_upload_instruction}}
			</p>
			<div class="video-area">
				<div v-for="(document, index) in applicant_documents">
					<div v-if="document.document_type == 'stage2video'">
						<video width="100%" height="300" controls>
							<source v-bind:src="'https://wajesmarthrms.website/public/'+document.link">
						</video>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AppVideo',
		props: {
			applicant_documents: {
				type: Array,
				required: true
			},

			opening: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				video_upload_instruction: ""
			}
		},
		methods: {
			getVideoUplaodInfromation: function () {
				var iv = {
					what: 'InterviewVideos',
					id: this.opening
				}

				this.$socket.makeGetRequest(iv)
					.then((response) => {
						this.video_upload_instruction = response.data[0].instruction
					})
					.catch((error) => {
						this.video_upload_instruction = error.message
						//this.$swal.fire('An error occured', error.message, 'error')
						console.log(error)
					})
			}
		},
		mounted() {
			this.getVideoUplaodInfromation()
		}
	}
</script>